<template>
  <div class="form-group" :class="computedClasses">
    <div class="" :class="{'input-group': grpPrependSlot || grpAppendSlot}">
      <div class="input-group-prepend" v-if="grpPrependSlot">
        <slot name="grpPrepend"></slot>
      </div>

      <input
        :type="type"
        data-toggle="tooltip-city"
        class="form-control"
        :class="inputClasses"
        :name="name"
        :id="id"
        :placeholder="placeholder"
        :title="title"
        v-model.trim="valueCopy"

        :readonly="readonly"
        :disabled="disabled"
        :autocomplete="autocomplete"

        :max="max"
        :min="min"
        :step="step"
        :minlength="minlength"
        :maxlength="maxlength"
        :required="required"

        @focus="handleFocus(true)"
        @blur="handleFocus(false)"
        @input="handleModelInput"
        @keydown.down="onKeyDown"
        @keydown.up="onKeyUp"
        @keydown.enter="onKeyEnter"
        @keydown.tab="onKeyEnter"
      >

      <div class="input-group-append" v-if="grpAppendSlot">
        <slot name="grpAppend"></slot>
      </div>

      <label class="material-label" :class="{...activeClass, ...labelClass}" :for="id">
        <slot></slot>
      </label>
      <small v-if="error" class="invalid-feedback">{{ error }}</small>
    </div>
    <HelpSpan :helpText="helpText" :truncateText="helpTruncate" />
  </div>
</template>

<script>
  export default {
    name: 'material-input',
    components: {
        HelpSpan: () => import(/* webpackChunkName: "help-span" */ '@/components/form/HelpSpan.vue'),
    },
    computed: {
      computedErrors () {
        return typeof this.errorMessages === 'string'
          ? [this.errorMessages] : this.errorMessages
      },
      computedClasses () {
        return {
          'material--active': this.focus,
          'material--disabled': this.disabled,
          'material--has-errors': Boolean(
            !this.valid ||
            (this.errorMessages && this.errorMessages.length)),
          'material--raised': Boolean(
            this.focus ||
            this.hasValue || // has value
            (this.placeholder && !this.hasValue)) // has placeholder
        }
      },
      activeClass () {
        return {
          'active': Boolean(
            this.focus ||
            this.hasValue || // has value
            (this.placeholder && !this.hasValue)) // has placeholder
        }
      },
      grpPrependSlot() {
          if (this.$scopedSlots) {
              return this.$scopedSlots.grpPrepend;
          }
          return null;
      },
      grpAppendSlot() {
          if (this.$scopedSlots) {
              return this.$scopedSlots.grpAppend;
          }
          return null;
      },
      hasValue() {
        return this.valueCopy != undefined && this.valueCopy != null && (this.valueCopy+'').trim() !== ''
      },
    },
    data () {
      return {
        valueCopy: null,
        focus: false,
        valid: true
      }
    },
    beforeMount () {
      // Here we are following the Vue2 convention on custom v-model:
      // https://github.com/vuejs/vue/issues/2873#issuecomment-223759341
      this.copyValue(this.value)
    },
    mounted() {

    },
    methods: {
      handleModelInput(event) {
        this.$emit('input', event.target.value, event)
        this.handleValidation()
      },
      handleFocus(focused) {
        if(!(this.disabled || this.readonly)){
          this.focus = focused
        }
      },
      handleValidation() {
        this.valid = this.$el ? this.$el.querySelector('.form-control').validity.valid : this.valid
      },
      copyValue (value) {
        this.valueCopy = value
        this.handleValidation()
      },
      onKeyDown(event) {
          this.$emit('keyDown', event)
      },
      onKeyUp(event) {
          this.$emit('keyUp', event)
      },
      onKeyEnter(event) {
          this.$emit('keyEnter', event)
      },
      onFocus(event) {
          this.$emit('focus', event)
      },
      onBlur(event) {
          this.$emit('blur', event)
      },
    },
    watch: {
      value (newValue) {
        // This watch works from the code side of the 2-way-binding:
        this.copyValue(newValue)
      },
      focus (newValue) {
        newValue ? this.onFocus(newValue) : this.onBlur(newValue);
      }
    },
    props: {
      id: {
        type: String,
        default: null
      },
      name: {
        type: String,
        default: null
      },
      type: {
        type: String,
        default: 'text'
      },
      value: {
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      title: {
        type: String,
        default: null
      },
      readonly: {
        type: Boolean,
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      min: {
        type: [String, Number],
        default: null
      },
      max: {
        type: [String, Number],
        default: null
      },
      step: {
        type: Number,
        default: null
      },
      minlength: {
        type: Number,
        default: null
      },
      maxlength: {
        type: Number,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      autocomplete: {
        type: String,
        default: 'off',
      },
      errorMessages: {
        type: [Array, String],
        default: null
      },
      inputClasses: {
        type: [Array, Object, String],
        default: null
      },
      error: {
        type: String,
        default: null
      },
      helpText: {
        type: String,
        default: null
      },
      helpTruncate: {
        type: Boolean,
        default: true
      },
      labelClass: {
        type: Object,
        default: ()=> {return {}},
      },
    }
  }
</script>